export default __webpack_public_path__ + "static/media/bar.4cb7cdf5.webp";